module.exports = __webpack_public_path__ + "static/media/Facebook Messenger.0cdfd0fd.png";